import { FeatureKinds, kindFor } from './featureKind';
import { FeatureSwitchState } from './featureState';
import { featureStateFor } from './featureSwitches';
import { FeatureSwitchTable } from './featureSwitchesCache';

/**
 * The switch state that decides this feature, or `undefined` where the switch
 * row has no say and the account's grants decide.
 */
export function governingSwitchState(
  feature: string,
  switches: FeatureSwitchTable,
  featureKinds: FeatureKinds | null | undefined
): FeatureSwitchState | undefined {
  if (!switches.active || kindFor(featureKinds, feature) !== 'release-flag') {
    return undefined;
  }

  return featureStateFor(switches.switches, feature);
}
